/**
 * MM BOGO Guard
 * Silently blocks promo/discount codes while a BOGO offer is active in the cart.
 */
(function () {
  if (window.__mmBogoGuardLoaded) return;
  window.__mmBogoGuardLoaded = true;

  var lastClearedAt = 0;
  var MM_OFFER_DISCOUNT = /bogo|bundle|volume|flash|wheel|gift|prize|deal|tier|smart/i;

  function isMmOfferDiscount(title) {
    if (!title) return false;
    return MM_OFFER_DISCOUNT.test(String(title));
  }

  function hasBogoInCart(cart) {
    if (!cart) return false;
    if (cart.attributes) {
      var raw = cart.attributes._flash_deals_data;
      if (raw) {
        try {
          var deals = JSON.parse(raw);
          if (Array.isArray(deals)) {
            for (var i = 0; i < deals.length; i++) {
              var t = deals[i] && deals[i].type;
              if (t === "bogo" || t === "bogo_trigger") return true;
            }
          }
        } catch (e) {}
      }
      if (cart.attributes._mm_has_bogo_offer === "true") return true;
    }
    if (cart.items) {
      for (var j = 0; j < cart.items.length; j++) {
        var props = (cart.items[j] && cart.items[j].properties) || {};
        if (String(props._offerType || "").toUpperCase() === "BOGO") return true;
      }
    }
    return false;
  }

  function hasPromoCodeApplied(cart) {
    if (!cart) return false;
    if (cart.discount_codes && cart.discount_codes.some(function (d) {
      return d && d.code && (d.applicable === undefined || d.applicable);
    })) {
      return true;
    }
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      for (var i = 0; i < cart.cart_level_discount_applications.length; i++) {
        var app = cart.cart_level_discount_applications[i];
        if (app && !isMmOfferDiscount(app.title)) return true;
      }
    }
    if (cart.applied_discount && cart.applied_discount.title && !isMmOfferDiscount(cart.applied_discount.title)) {
      return true;
    }
    if (cart.items) {
      for (var j = 0; j < cart.items.length; j++) {
        var apps = (cart.items[j] && cart.items[j].discounts) || [];
        for (var k = 0; k < apps.length; k++) {
          if (apps[k] && apps[k].title && !isMmOfferDiscount(apps[k].title)) return true;
        }
      }
    }
    return false;
  }

  function clearDiscountAllMethods() {
    if (Date.now() - lastClearedAt < 1500) return;
    lastClearedAt = Date.now();
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount: "" }),
      credentials: "same-origin",
    }).catch(function () {});
    fetch("/discount/clear", { credentials: "same-origin" }).catch(function () {});
    var removeBtn = document.querySelector(
      "[data-discount-remove], .discount-remove, [aria-label*='Remove discount' i], .tag__remove, .cart__discount-remove, [data-cart-discount-remove]"
    );
    if (removeBtn) {
      try { removeBtn.click(); } catch (e) {}
    }
    var input = document.querySelector(
      "input[name='discount'], input[name='discount_code'], input[name='reduction_code']"
    );
    if (input) {
      try { input.value = ""; } catch (e) {}
    }
  }

  function checkAndEnforce() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !hasBogoInCart(cart) || !hasPromoCodeApplied(cart)) return;
        clearDiscountAllMethods();
      })
      .catch(function () {});
  }

  function maybeStripDiscountUrl() {
    var path = window.location.pathname || "";
    var search = window.location.search || "";
    var match = path.match(/\/discount\/([^/?#]+)/i) || search.match(/[?&]discount=([^&]+)/i);
    if (!match) return;
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (hasBogoInCart(cart) && hasPromoCodeApplied(cart)) {
          clearDiscountAllMethods();
        }
      })
      .catch(function () {});
  }

  function hookForms() {
    document.addEventListener(
      "submit",
      function (e) {
        var form = e.target;
        if (!form || !form.action) return;
        var action = String(form.action);
        if (!/discount/i.test(action) && !/\/cart/i.test(action)) return;
        var input = form.querySelector(
          "input[name='discount'], input[name='discount_code'], input[name='reduction_code']"
        );
        if (!input || !input.value) return;
        fetch("/cart.js", { credentials: "same-origin" })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            if (hasBogoInCart(cart)) {
              try { input.value = ""; } catch (err) {}
              clearDiscountAllMethods();
            }
          });
        setTimeout(checkAndEnforce, 1500);
      },
      true
    );
  }

  function startMonitoring() {
    maybeStripDiscountUrl();
    hookForms();
    checkAndEnforce();
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") checkAndEnforce();
    });
    window.addEventListener("focus", checkAndEnforce);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startMonitoring);
  } else {
    startMonitoring();
  }

  window.MMBogoGuard = { check: checkAndEnforce };
})();
